// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { EntityList, Promotion } from "../flow/types";

export default function (state = initialState.promotions, action) {
  switch (action.type) {
    case ActionTypes.GET_ACTIVE_PROMOTIONS + ActionTypes.FULFILLED:
      var data = action.payload.data;
      const result: EntityList<Promotion> = new EntityList(data, 1);
      return result;
    case ActionTypes.GET_PROMOTIONS_ITEMS + ActionTypes.FULFILLED: {
           const PromotionData = action.payload?.data || {};
            return {
              ...state,
              list: {
                items: PromotionData.NewPromoItems || [],  
                removedItems: PromotionData.RemovedPromoItems || [],  
                totalCount: PromotionData.TotalCount || PromotionData.NewPromoItems?.length || 0,
                loading: false
              }
            };
          }
    case ActionTypes.RESET_GET_PROMOTIONS_ITEMS:
            return {
              ...state,
                list: { items: [], removedItems:[], totalCount: 0, loading: true }
            };
    case ActionTypes.GET_StockItem_To_Add + ActionTypes.FULFILLED:
      const sale = action.payload?.data || {};
      return {
        ...state,
        checkoutSale: sale.sale
      };
    default:
      return state;
  }
}
